// extracted by mini-css-extract-plugin
export default {"toolSection":"ModifierCard_toolSection__KhucY","toolTitle":"ModifierCard_toolTitle__KfCUg"};